export default "__VITE_ASSET__11e233ec__"